module.exports = __webpack_public_path__ + "img/视频号：正好是个设计鬼才.9b9e3090.png";